module.exports = __webpack_public_path__ + "files/3538dc6c6e35eec1aef7b50ba66356ba.svg";